<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <div class="Info_Area">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="農產品交易價量分析(日)">
            <DashboardForCropInDay />
          </b-tab>
          <b-tab title="農產品交易價量分析(月)">
            <DashboardForCropInMonth />
          </b-tab>
          <b-tab title="農產品交易價量分析(年)">
            <DashboardForCropInYear />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import DashboardForCropInDay from "./DashboardForCropInDay.vue";
import DashboardForCropInMonth from "./DashboardForCropInMonth.vue";
import DashboardForCropInYear from "./DashboardForCropInYear.vue";

export default {
  name: "MainDashBoardForCrop",
  data() {
    return {
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "農產品交易價量分析",
          active: true,
        },
      ],
    };
  },
  components: {
    DashboardForCropInDay,
    DashboardForCropInMonth,
    DashboardForCropInYear,
  },
};
</script>
